module.exports = __webpack_public_path__ + "img/2.95d69956.svg";